import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getUser, isAuthenticated } from "@/services/userLogin";

export function RequirePasswordChange({ children }: { children: ReactNode }) {
  if (isAuthenticated() && getUser()?.must_change_password) {
    return <Navigate to="/setup-password" replace />;
  }
  return <>{children}</>;
}
